import i18n from 'i18n'
import { MessageConst } from 'enums'
import MeasureType, { MeasureTypeStrings } from 'enums/MeasureType'
import { ChartConfig } from '../types'

// eslint-disable-next-line import/prefer-default-export
export const getDisabledReason = (category: MeasureTypeStrings) => {
  switch (category) {
    case MeasureType.NET_SENTIMENT:
      return i18n.t('notAvailableNetSentiment')
    case MeasureType.POSITIVES:
      return i18n.t('notAvailablePositives')
    case MeasureType.NEGATIVES:
      return i18n.t('notAvailableNegatives')
    case MeasureType.PASSION_INTENSITY:
      return i18n.t('notAvailablePassionIntensity')
    default:
      return ''
  }
}

export const isDisabled = (chartConfig: ChartConfig) =>
  chartConfig.value === MessageConst.NOT_AVAILABLE_ABBR

export const createDisabledInfo = (chartConfig: ChartConfig) => {
  if (isDisabled(chartConfig)) {
    return {
      isDisabled: true,
      reason: getDisabledReason(chartConfig.category)
    }
  }

  return {
    isDisabled: false,
    reason: null
  }
}
